import { render, staticRenderFns } from "./PaymentLinkForm.vue?vue&type=template&id=8463d99c&scoped=true"
import script from "./PaymentLinkForm.vue?vue&type=script&lang=js"
export * from "./PaymentLinkForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkForm.vue?vue&type=style&index=0&id=8463d99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8463d99c",
  null
  
)

export default component.exports